import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Form, Input, Button, message } from 'antd';
import { withOnFocus } from '../../../../../components/HOC';
import AddressSearchBox from '../../../../../components/AddressSearchBox/AddressSearchBox';
import { createBranch, updateBranch } from '../BranchAction';
import { orgIdSelector } from '../../../OrganisationSelectors';
import { loadingBranchesSelector } from '../BranchSelectors';
import { MSG_SAVE_SUCCESS, MSG_ERROR } from '../../../../../constants';
import { getApiErrorMessage } from '../../../../../utils/httpError';
import explanations from '../data/explanations.json';

const FormItem = Form.Item;

class BranchEdit extends Component {
  constructor(props) {
    super(props);
    this.InputWithOnFocus = withOnFocus(Input, props.onExplanationChange);
    this.SearchBoxWithOnFocus = withOnFocus(AddressSearchBox, props.onExplanationChange);
  }

  onSubmit = e => {
    e.preventDefault();
    const { form, orgId, branchInfo, createBranch, updateBranch, close } = this.props;
    form.validateFields(async (err, fieldsValue) => {
      if (!err) {
        const values = Object.keys(fieldsValue).reduce((acc, key) => {
          acc[key] =
            fieldsValue[key] && typeof fieldsValue[key] === 'string' ? fieldsValue[key].trim() : fieldsValue[key];
          return acc;
        }, {});
        try {
          if (branchInfo) {
            const { branchId } = branchInfo;
            await updateBranch(orgId, branchId, values);
          } else {
            await createBranch(orgId, values);
          }
          message.success(MSG_SAVE_SUCCESS);
          close();
        } catch (err) {
          message.error(getApiErrorMessage(err, MSG_ERROR));
        }
      }
    });
  };

  render() {
    const { InputWithOnFocus, SearchBoxWithOnFocus } = this;
    const { form, branchInfo = {}, loading } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Form>
        <FormItem label="Name">
          {getFieldDecorator('name', {
            initialValue: branchInfo.name,
            rules: [{ required: true, message: 'Please input the branch name.' }]
          })(<InputWithOnFocus placeholder="Name" disabled={loading} explanation={explanations.name} />)}
        </FormItem>
        <Row gutter={20}>
          <Col span={16}>
            <FormItem label="Address">
              {getFieldDecorator('address', {
                initialValue: branchInfo.address,
                rules: [{ required: true, message: 'Please input the branch address.' }]
              })(<SearchBoxWithOnFocus placeholder="Address" disabled={loading} explanation={explanations.address} />)}
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem label="Unit/Suite/Floor">
              {getFieldDecorator('additionalAddressInformation', {
                initialValue: branchInfo.additionalAddressInformation
              })(
                <InputWithOnFocus
                  placeholder="Unit/Suite/Floor"
                  disabled={loading}
                  explanation={explanations.additionalAddressInformation}
                />
              )}
            </FormItem>
          </Col>
        </Row>
        <FormItem label="Email">
          {getFieldDecorator('email', {
            initialValue: branchInfo.email,
            validateTrigger: 'onBlur',
            rules: [{ type: 'email', message: 'Please input an valid email.' }]
          })(
            <InputWithOnFocus
              placeholder="Email"
              disabled={loading}
              spellCheck={false}
              explanation={explanations.email}
            />
          )}
        </FormItem>
        <FormItem label="Phone">
          {getFieldDecorator('phone', { initialValue: branchInfo.phone })(
            <InputWithOnFocus placeholder="Phone" disabled={loading} explanation={explanations.phone} />
          )}
        </FormItem>
        <FormItem>
          <Button type="primary" block loading={loading} onClick={this.onSubmit}>
            {loading ? 'Saving' : 'Save'}
          </Button>
        </FormItem>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  orgId: orgIdSelector(state),
  loading: loadingBranchesSelector(state)
});

const mapDispatchToProps = { createBranch, updateBranch };

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(BranchEdit));
